import ActionName from '@/enums/action-name';
import { RoleProtectedFeature } from '@/enums/feature-names';
import { Privilege } from '@/enums/privilege';
import { RouteName } from '@/enums/route-name';

const REQUIRED_PRIVILEGES: Record<RoleProtectedFeature, Privilege[]> = {
    [RouteName.GPP_USERS]: [Privilege.AS_SHOW_GPP_TILE],
    [RouteName.CREATE_GPP_USER]: [Privilege.AS_UM_CREATE_USER],
    [RouteName.COPY_GPP_USER]: [Privilege.AS_SHOW_GPP_TILE],
    [RouteName.VIEW_GPP_USER]: [Privilege.AS_SHOW_GPP_TILE],
    [RouteName.EDIT_GPP_USER]: [Privilege.AS_UM_CHANGE_USER],
    [RouteName.SHIPIT_ADMINISTRATION]: [Privilege.AS_SHOW_SHIPIT_TILE],
    [RouteName.CREATE_SHIPIT_FARM_USER]: [Privilege.AS_UM_CREATE_USER],
    [RouteName.CREATE_SHIPIT_WEB_USER]: [Privilege.AS_UM_CREATE_USER],
    [RouteName.EDIT_SHIPIT_FARM_USER]: [Privilege.AS_UM_CHANGE_USER],
    [RouteName.EDIT_SHIPIT_WEB_USER]: [Privilege.AS_UM_CHANGE_USER],
    [RouteName.CHANGE_SHIPPER_SETTINGS]: [Privilege.AS_SM_CHANGE_SHIPPER],
    [RouteName.TRACKING]: [Privilege.AS_SHOW_TRACKING_TILE],
    [RouteName.TRACKING_CREATE_USER]: [Privilege.AS_UM_CREATE_USER],
    [RouteName.TRACKING_EDIT_USER]: [Privilege.AS_UM_CHANGE_USER],
    [RouteName.ACTION_LOG]: [Privilege.AS_SHOW_ACTION_LOG_TILE],
    [ActionName.CREATE_USER]: [Privilege.AS_UM_CREATE_USER],
    [ActionName.EDIT_USER]: [Privilege.AS_UM_CHANGE_USER],
    [ActionName.DELETE_USER]: [Privilege.AS_UM_DELETE_USER],
    [ActionName.CHANGE_USER_ACTIVE_STATUS]: [Privilege.AS_UM_CHANGE_USER_DISABLE],
    [ActionName.CHANGE_USER_ROLE]: [Privilege.AS_UM_CHANGE_USER_ROLE],
    [ActionName.CHANGE_USER_AUTH_TYPE]: [Privilege.AS_UM_CHANGE_USER_AUTH_TYPE],
    [ActionName.CHANGE_ASSIGN_SHIPPER]: [Privilege.AS_UM_CHANGE_ASSIGN_SHIPPER],
    [ActionName.CHANGE_REMOVE_SHIPPER]: [Privilege.AS_UM_CHANGE_REMOVE_SHIPPER],
    [ActionName.CHANGE_ASSIGN_SHIPPER_WILDCARD]: [Privilege.AS_UM_CHANGE_ASSIGN_SHIPPER_WILDCARD],
    [ActionName.CHANGE_ASSIGN_LOCATION_WILDCARD]: [Privilege.AS_UM_CHANGE_ASSIGN_LOCATION_WILDCARD],
    [ActionName.SEE_CORE_REGION_USERS]: [Privilege.SEE_CORE_REGION_USERS],
    [ActionName.VIEW_SHIPPER]: [Privilege.AS_SM_VIEW_SHIPPER], //TODO screen for this permission does not exist yet, no task
    [ActionName.CHANGE_SHIPPER]: [Privilege.AS_SM_CHANGE_SHIPPER],
    [ActionName.TIMEOUTS_LVR]: [Privilege.AS_SM_TIMEOUTS_LVR],
    [ActionName.TIMEOUTS_CBR]: [Privilege.AS_SM_TIMEOUTS_CBR],
    [ActionName.TIMEOUTS_SSR]: [Privilege.AS_SM_TIMEOUTS_SSR],
    [ActionName.TIMEOUTS_CCO]: [Privilege.AS_SM_TIMEOUTS_CCO],
    [ActionName.TIMEOUTS_ISRS]: [Privilege.AS_SM_TIMEOUTS_ISRS],
    [ActionName.TIMEOUTS_IT]: [Privilege.AS_SM_TIMEOUTS_IT],
    [ActionName.ROUTING_STRATEGY]: [Privilege.AS_SM_ROUTING_STRATEGY],
    [ActionName.REAL_SHIPPER_ALLOWED]: [Privilege.AS_SM_REAL_SHIPPER_ALLOWED],
    [ActionName.TRACK_ID_INJECTION]: [Privilege.AS_SM_TRACK_ID_INJECTION],
    [ActionName.ONBOARDING]: [Privilege.AS_UM_MANAGE_REQUEST_LIST]
};

export default REQUIRED_PRIVILEGES;
